import { useContext } from 'react'
import { PathContext } from '@contexts/PathContext'
import { IEnrollment } from '@dtos/Enrollment'
import { ICourse } from '@dtos/Course'

interface IUsePath {
  enrollment?: IEnrollment | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  newEnrollment: any
  enrollmentIsLoading: boolean
  coursesInPath: ICourse[]
  onLoadMore: () => Promise<void>
  hasMore: boolean
}

export const usePath = (): IUsePath => {
  const {
    enrollment,
    newEnrollment,
    enrollmentIsLoading,
    onLoadMore,
    hasMore,
  } = useContext(PathContext)

  return {
    enrollment,
    newEnrollment: newEnrollment?.enrollment,
    enrollmentIsLoading,
    coursesInPath:
      newEnrollment?.enrollment?.progressCard?.courseProgressCards || [],
    onLoadMore,
    hasMore: hasMore ?? true,
  }
}
